import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function RedeemAccessCode({ onRedeemed }) {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  if (!user) return null;

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await api.post("/access-codes/redeem", { code });
      toast.success(`${r.data.plan_label} unlocked`);
      await refresh?.();
      onRedeemed ? onRedeemed() : navigate("/dashboard");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "That code isn't valid"); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="rounded-2xl border border-dashed border-border bg-card/60 p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="redeem-access-code">
      <p className="text-sm flex items-center gap-2 sm:flex-1"><KeyRound className="w-4 h-4 text-accent" /> Have an access code?</p>
      <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Enter code" className="font-mono sm:w-48" required data-testid="redeem-code-input" />
      <Button type="submit" variant="outline" disabled={busy || !code.trim()} data-testid="redeem-code-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Apply"}</Button>
    </form>
  );
}
